import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
}

const EmptyState = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 96 95">
      <path d="M48,93.6619718 C22.2787606,93.6619718 1.35211268,72.9533099 1.35211268,47.5 C1.35211268,22.0466901 22.2787606,1.33802817 48,1.33802817 C73.7212394,1.33802817 94.6478873,22.0466901 94.6478873,47.5 C94.6478873,72.9533099 73.7212394,93.6619718 48,93.6619718 M48,0 C21.5323944,0 0,21.3080986 0,47.5 C0,73.6919014 21.5323944,95 48,95 C74.4676056,95 96,73.6919014 96,47.5 C96,21.3080986 74.4676056,0 48,0 M66.0964056,61.6408169 L62.2902085,65.4073662 L47.9997296,51.2684225 L33.7106028,65.4073662 L29.9030535,61.6408169 L44.1921803,47.5005352 L29.9030535,33.3589155 L33.7106028,29.5923662 L47.9997296,43.7326479 L62.2902085,29.5923662 L66.0964056,33.3589155 L51.8072789,47.5005352 L66.0964056,61.6408169 Z M62.2902085,27.7003944 L47.9997296,41.8406761 L33.7106028,27.7003944 L27.9911662,33.3589155 L42.280293,47.5005352 L27.9911662,61.6408169 L33.7106028,67.299338 L47.9997296,53.1603944 L62.2902085,67.299338 L68.008293,61.6408169 L53.7191662,47.5005352 L68.008293,33.3589155 L62.2902085,27.7003944 Z" />
    </svg>
  );
};

export default EmptyState;
